import { Banner, Stack } from './styles';
import { useKsPackageState } from './hooks/useKsPackageState';
import { KsPackagesContent } from './components/KsPackagesContent';
import { apiErr, isKsPackagesDisabled } from './helpers';

export function KsPackages() {
  const state = useKsPackageState();

  if (state.disabled) {
    return (
      <Banner>
        Пакет акта отключён на сервере. Включите <code>OSNOVA_KS_PACKAGE_ENABLED=1</code> в
        окружении backend — без флага группа роутов не регистрируется.
      </Banner>
    );
  }

  return (
    <Stack>
      {state.notice && <Banner>{state.notice}</Banner>}
      <KsPackagesContent state={state} />
    </Stack>
  );
}

export { apiErr, isKsPackagesDisabled };
export default KsPackages;
